module.exports = __webpack_public_path__ + "static/est-c545c2ef39e7494c60bfaae977dd8a4f.png";